import { AuthenticationLoadingLayout } from "#src/batteries-included-components/Layouts/Authentication/AuthenticationLoading";
import { Brandmark } from "#src/components/Presentational/Logos/Brandmark";
import { LoadingState } from "@validereinc/common-components";
import React from "react";

export const LoadingOnLoginRedirect = () => {
  return (
    <AuthenticationLoadingLayout>
      <LoadingState
        label="Redirecting to log in..."
        size="large"
        indicator={<Brandmark isAnimated />}
      />
    </AuthenticationLoadingLayout>
  );
};
